/* eslint-disable react/no-array-index-key */
import * as React from 'react';
import {ReactNode} from 'react';

import {MerieSchema} from '../../types';

export const DRP_FLEX_COLUMN: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  maxWidth: '100%',
};
export const DRP_GAP = 8;
export const DRP_DIVIDER_HEIGHT = 1;
export const DRP_LINE_HEIGHT = 18;
export const DRP_FONT_SIZE = 12; // TODO: stop using DRP_FONT_SIZE
export const DRP_PAD_Y = 0;
export const DRP_CHIP_GAP = 6;

export type PhDrugRelatedProblemDto = MerieSchema.components['schemas']['DrugRelatedProblemPageDto'];

function getDrpHeight(drp: PhDrugRelatedProblemDto): number {
  const causesHeight = (DRP_LINE_HEIGHT + DRP_PAD_Y + DRP_CHIP_GAP) * drp.causes.length - DRP_CHIP_GAP;
  const interventionsHeight = (DRP_LINE_HEIGHT + DRP_PAD_Y + DRP_CHIP_GAP) * drp.plannedInterventions.length - DRP_CHIP_GAP;
  return Math.max(0, causesHeight, interventionsHeight);
}
export function getDrpsHeight(drps: PhDrugRelatedProblemDto[]): number {
  const totalDrpsHeight = drps.reduce((acc, drp) => acc + getDrpHeight(drp), 0);
  const totalGapsHeight = (2 * DRP_GAP + DRP_DIVIDER_HEIGHT) * Math.max(0, drps.length - 1);
  return Math.max(totalDrpsHeight + totalGapsHeight, 20);
}

export type PhRecommendationDrpBaseFormatterProps = {
  problems: PhDrugRelatedProblemDto[];
  renderContent: (drp: PhDrugRelatedProblemDto, drpHeight: number) => ReactNode;
  dividerWidthOffset: number;
};

export const PhRecommendationDrpBaseFormatter: React.FC<PhRecommendationDrpBaseFormatterProps> = (props) => {
  const {problems = [], renderContent, dividerWidthOffset} = props;

  return (
    <div style={{...DRP_FLEX_COLUMN, rowGap: DRP_GAP}}>
      {problems.length > 0
        ? problems.map((drp, i) => {
            const drpHeight = getDrpHeight(drp);
            return (
              <React.Fragment key={i}>
                {i !== 0 && <MedicationDivider dividerWidthOffset={dividerWidthOffset} />}
                {renderContent(drp, drpHeight)}
              </React.Fragment>
            );
          })
        : '-'}
    </div>
  );
};

PhRecommendationDrpBaseFormatter.displayName = 'PharmaRecommendationBaseDrpFormatter';

type MedicationDividerProps = {
  dividerWidthOffset?: number;
};

export const MedicationDivider: React.FC<MedicationDividerProps> = (props) => {
  const {dividerWidthOffset = 0} = props;
  return (
    <div
      style={{
        width: '100%',
        height: DRP_DIVIDER_HEIGHT,
        position: 'relative',
      }}
    >
      <hr
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          margin: 0,
          width: `calc(100% + ${dividerWidthOffset}px)`,
          height: DRP_DIVIDER_HEIGHT,
          background: 'var(--dlThemeGray-300)',
        }}
      />
    </div>
  );
};
